// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.lawspan {\n  color: #0072c6 !important;\n  font-size: 13px !important;\n  font-weight: 600;\n}\n.divchklaw {\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
